import { render, staticRenderFns } from "./chart-header.vue?vue&type=template&id=067066bc"
import script from "./chart-header.vue?vue&type=script&lang=js"
export * from "./chart-header.vue?vue&type=script&lang=js"
import style0 from "./chart-header.vue?vue&type=style&index=0&id=067066bc&prod&lang=css"
import style1 from "./chart-header.vue?vue&type=style&index=1&id=067066bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports